import React from "react";
import bus from "./bus.png";
import { Button } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { BsChevronBarDown } from "react-icons/bs";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import {
  useGetBookingFacilityDetailsQuery,
  useGetBookingFacilityQuery,
  useViewBookingDetailsQuery,
} from "../../../../api/financeApi";
import {
  FormatStatus,
  getColorByStatus,
} from "../../../../../utils/functions/FormatStatus";
const ManageBookingRequestView = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const { data, isLoading } = useViewBookingDetailsQuery(id);
  const details = data?.result;
  const { data: facilityData, isLoading: facilityLoading } =
    useGetBookingFacilityQuery({
      PageSize: 1000,
      PageNumber: 1,
    });

  // write a func that accepts an id and returns the data, map through facilityData and return the data
  const getFacilityData = (id) => {
    const data = facilityData?.result?.items?.find((x) => x.id === id);
    return data?.facilityName;
  };

  // console.log({ facilityData, facilityLoading });

  return (
    <RouteLayout>
      <div className="mb-5">
        <Button
          startIcon={<ArrowBackIcon />}
          variant="outlined"
          style={{ marginRight: "10px" }}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </div>

      <div className="flex justify-between mb-5">
        <div>
          <h3 className="text-[34] font-bold text-[#6E9170]">
            Booking Requests Details
          </h3>
        </div>
        {/* <Button
          endIcon={<BsChevronBarDown color="#fff" />}
          className="bg-[#4B664C] text-white px-4 py-2 rounded-lg"
        >
          Action
        </Button> */}
      </div>

      <div className="p-6 bg-white rounded-lg shadow">
        {/* Process Information Section */}
        <div className="mb-8 p-6 bg-[#F7FAF9] rounded-lg border">
          <h2 className="text-lg font-semibold text-[#6E9170] mb-4">
            Process Information
          </h2>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div className="flex justify-between">
              <span className="font-medium">Requested By:</span>
              <span>{details?.createdBy}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Email:</span>
              <span>N/A</span> {/* No email provided in the data */}
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Phone Number:</span>
              <span>N/A</span> {/* No phone number provided in the data */}
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Date Requested:</span>
              <span>{new Date(details?.createdDate).toLocaleDateString()}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Status:</span>
              <span
                style={{
                  color: getColorByStatus(details?.approvalStatus).color,
                  backgroundColor: getColorByStatus(details?.approvalStatus)
                    .backgroundColor,
                  padding: "4px", // Optional padding for better visual presentation
                  borderRadius: "4px", // Optional rounded corners
                }}
              >
                {FormatStatus(details?.approvalStatus)}
              </span>
            </div>
          </div>
        </div>

        {/* Basic Information Section */}
        <div className="mb-8 p-6 bg-[#F7FAF9] rounded-lg border">
          <h2 className="text-lg font-semibold text-[#6E9170] mb-4">
            Basic Information
          </h2>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div className="flex justify-between">
              <span className="font-medium">Service Name:</span>
              <span>{details?.requisitorName}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Facility Name:</span>
              <span>{getFacilityData(details?.facilityId)}</span>{" "}
              {/* Assuming facilityId maps to name */}
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Components:</span>
              <span>{details?.components}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Special Request:</span>
              <span>{details?.specialRequest || "None"}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Start Date:</span>
              <span>{new Date(details?.startDate).toLocaleDateString()}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">End Date:</span>
              <span>{new Date(details?.endDate).toLocaleDateString()}</span>
            </div>
          </div>
        </div>

        {/* Component Information Section */}
        <div className="mb-8 p-6 bg-[#F7FAF9] rounded-lg border">
          <h2 className="text-lg font-semibold text-[#6E9170] mb-4">
            Component Information
          </h2>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div className="flex justify-between">
              <span className="font-medium">Name:</span>
              <span>{details?.components}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Description:</span>
              <span>Component Description</span>{" "}
              {/* Placeholder if no description available */}
            </div>
            {/* <div className="flex justify-between">
              <span className="font-medium">Status:</span>
              <span className="text-green-600">
                {FormatStatus(details?.approvalStatus) === 7 ? "Pending" : "Active"}
              </span>
            </div> */}
            <div className="flex justify-between">
              <span className="font-medium">Location:</span>
              <span>Lagos</span> {/* Assuming location is fixed */}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        {/* <div className="flex justify-end">
          <Button className="bg-[#AC0000] text-white px-4 py-2 rounded-lg">
            Decline
          </Button>
          <button className="bg-[#4B664C] text-white px-4 py-2 rounded-lg">
            Approve
          </button>
        </div> */}
      </div>

      {/* <div className="flex justify-between mb-5">
        <div>
          <h3 className="text-[34] font-bold text-[#6E9170]">
            Service Details
          </h3>
        </div>
        <Button
          endIcon={<BsChevronBarDown color="#fff" />}
          className="bg-[#4B664C] text-white px-4 py-2 rounded-lg"
        >
          Action
        </Button>
      </div>
      <div className="p-6 bg-white rounded-lg shadow">
        <div className="mb-8 p-6 bg-[#F7FAF9] rounded-lg border">
          <h2 className="text-lg font-semibold text-[#6E9170] mb-4">
            Service Information
          </h2>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div className="flex justify-between">
              <span className="font-medium">Service Name:</span>
              <span>Fleets</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Total:</span>
              <span>40</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Total Unavailable:</span>
              <span>4</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Price Per Unit:</span>
              <span>45,000</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Total Available:</span>
              <span>36</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Status:</span>
              <span className="text-green-600">Active</span>
            </div>
          </div>
        </div>
        <div className="mb-8 p-6 bg-[#F7FAF9] rounded-lg border">
          <h2 className="text-lg font-semibold text-[#6E9170] mb-4">
            Facilities Information
          </h2>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div className="flex justify-between">
              <span className="font-medium">Facility Name:</span>
              <span>Toyota Hiace 16-Seaters Bus</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Quantity:</span>
              <span>36</span>
            </div>
            <div className="flex justify-between col-span-2">
              <span className="font-medium">Description:</span>
              <span>
                Ideal for group travel, the Toyota Hiace 16-Seater Bus offers
                comfortable seating for up to 16 passengers.
              </span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Available Quantity:</span>
              <span>4</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Status:</span>
              <span className="text-green-600">Available</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Location:</span>
              <span>Lagos</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Booking Price:</span>
              <span>34,000</span>
            </div>
          </div>
          <div className="flex justify-between mt-4">
     
            <div className="flex gap-2">
              <img src={bus} className="h-40 w-40 object-cover rounded-lg" />
              <img src={bus} className="h-40 w-40 object-cover rounded-lg" />
              <img src={bus} className="h-40 w-40 object-cover rounded-lg" />
              <img src={bus} className="h-40 w-40 object-cover rounded-lg" />
            </div>
          </div>
        </div>


        <div className="mb-8 p-6 bg-[#F7FAF9] rounded-lg border">
          <h2 className="text-lg font-semibold text-[#6E9170] mb-4">
            Component Information
          </h2>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div className="flex justify-between">
              <span className="font-medium">Name:</span>
              <span>Driver</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Quantity:</span>
              <span>36</span>
            </div>
            <div className="flex justify-between col-span-2">
              <span className="font-medium">Description:</span>
              <span>Placeholder</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Status:</span>
              <span className="text-green-600">Active</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Location:</span>
              <span>Lagos</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Optional:</span>
              <span>Yes</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium">Optional Price:</span>
              <span>34,000</span>
            </div>
          </div>
        </div>


        <div className="flex justify-end">
          <Button className="bg-[#AC0000] text-white px-4 py-2 rounded-lg">
            Decline
          </Button>
          <button className="bg-[#4B664C] text-white px-4 py-2 rounded-lg">
            Approve
          </button>
        </div>
      </div> */}
    </RouteLayout>
  );
};

export default ManageBookingRequestView;
